import React, { useState } from 'react';
import { useAuthStore } from '../../lib/store-auth';
import './login.scss';

interface LoginProps {
    onLoginSuccess: () => void;
}

export const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const { login } = useAuthStore();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!email || !password) {
            setError('Lütfen e-posta ve şifre girin');
            return;
        }

        setIsLoggingIn(true);
        setError(null);

        const result = await login(email, password);

        if (result.success) {
            onLoginSuccess();
        } else {
            setError(result.error || 'Giriş başarısız');
        }

        setIsLoggingIn(false);
    };

    return (
        <div className="login-page">
            <div className="login-container">
                {/* Logo */}
                <div className="login-logo">
                    <img src="/logo.svg" alt="Saletone" />
                </div>

                {/* Title */}
                <h1 className="login-title">Hoş Geldiniz</h1>
                <p className="login-subtitle">Devam etmek için giriş yapın</p>

                {/* Login Form */}
                <form className="login-form" onSubmit={handleSubmit}>
                    {/* Email */}
                    <div className="form-group">
                        <label htmlFor="email">E-posta</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="ornek@sirket.com"
                            autoComplete="email"
                        />
                    </div>

                    {/* Password */}
                    <div className="form-group">
                        <label htmlFor="password">Şifre</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="current-password"
                        />
                    </div>

                    {/* Error */}
                    {error && (
                        <div className="error-message">
                            <span className="material-symbols-outlined">error</span>
                            {error}
                        </div>
                    )}

                    {/* Submit */}
                    <button
                        type="submit"
                        className="login-button"
                        disabled={isLoggingIn}
                    >
                        {isLoggingIn ? (
                            <>
                                <div className="spinner"></div>
                                Giriş yapılıyor...
                            </>
                        ) : (
                            'Giriş Yap'
                        )}
                    </button>
                </form>

                {/* Footer */}
                <p className="login-footer">© 2026 Saletone. Tüm hakları saklıdır.</p>
            </div>
        </div>
    );
};
